__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-campaign-manager/v4_0_12/";